"use client";

import { FC } from "react";
import { useTranslations } from "next-intl";
import {
  LoadingSpinner,
} from "apps/website/components/form/LoadingSpinner/LoadingSpinner";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";

export const SignupLoadingScreen: FC = () => {
  const t = useTranslations("Shared.Actions");
  return (
    <div className="fixed inset-0 flex flex-col justify-center items-center gap-4">
      <LoadingSpinner color="black" size={32} />
      <TextSubtitle size={4}>{ t("loading") }</TextSubtitle>
    </div>
  );
};
